import React from "react";

import { Button, Modal } from "shared/ui";

import { useModifierSetsContext } from "features/ModifierSets/context";
import { localizedText } from "shared/lib/localizedMap";

export const DeleteModifierSetDialog = () => {
    const state = useModifierSetsContext();
    const { modifierSetToDelete } = state;

    return (
        <Modal
            open={!!modifierSetToDelete}
            onClose={state.closeDeleteDialog}
            title="Удаление набора"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={state.closeDeleteDialog}>
                        Отмена
                    </Button>
                    <Button
                        variant="contained"
                        color="danger"
                        disabled={state.saving}
                        onClick={state.confirmDelete}
                    >
                        Удалить
                    </Button>
                </>
            }
        >
            Набор «{modifierSetToDelete ? localizedText(modifierSetToDelete.name, state.locale) : ""}
            » будет удалён и отвяжется от всех позиций меню. Отменить это действие нельзя.
        </Modal>
    );
};
